export default __webpack_public_path__ + "static/media/3.f25e3fa8.jpg";